module.exports = "<div class=\"wrapper\">\r\n  <div class=\"main-panel\">\r\n      <app-navbar></app-navbar>\r\n  </div>\r\n</div>"